import React, { useState, useEffect } from 'react';
import {formatTime} from "../../utils/date-utils";

interface CountdownTimerProps {
    futureTimestamp: number;
}

const CountdownTimer: React.FC<CountdownTimerProps> = ({ futureTimestamp }) => {
    const [timeLeft, setTimeLeft] = useState(futureTimestamp - Date.now());

    useEffect(() => {
        if (timeLeft > 0) {
            const timer = setInterval(() => {
                const remaining = futureTimestamp - Date.now();
                if (remaining <= 0) {
                    clearInterval(timer);
                    setTimeLeft(0);
                } else {
                    setTimeLeft(remaining);
                }
            }, 1000);

            return () => clearInterval(timer);
        }
    }, [futureTimestamp, timeLeft]);

    return (
        <span>{formatTime(timeLeft)}</span>
    );
};

export default CountdownTimer;
